import React from 'react';
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  Grid,
} from "@mui/material";
import {
  HelpOutline as HelpIcon,
  ExpandMore as ExpandMoreIcon,
} from "@mui/icons-material";
import { colors, borderRadiusPx } from "../../../../../theme";
import { THREE_SLOT_CONFIG } from "./threeSlotConfig";

const ThreeSlotWorking = () => {
  return (
    <Box sx={{ mt: 4 }}>
      <Accordion
        sx={{
          borderRadius: `${borderRadiusPx.xl} !important`,
          border: `1px solid ${colors.dashboard.cardBorder || "#e2e8f0"}`,
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
          backgroundColor: "#ffffff",
          "&:before": { display: "none" },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <HelpIcon sx={{ color: "#8b5cf6", fontSize: 24 }} />
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 800, color: colors.slate[900] }}
            >
              {`How does ${THREE_SLOT_CONFIG.name} work?`}
            </Typography>
          </Stack>
        </AccordionSummary>
        <AccordionDetails sx={{ pt: 0, pb: 3, px: 3 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  p: 2.5,
                  bgcolor: "#f8fafc",
                  borderRadius: borderRadiusPx.lg,
                  border: `1px solid ${colors.slate[200]}`,
                  height: "100%",
                  transition: "border-color 0.2s ease, box-shadow 0.2s ease",
                  "&:hover": {
                    borderColor: "#d8b4fe",
                    boxShadow: "0 4px 12px rgba(139, 92, 246, 0.08)",
                  },
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 800, color: "#8b5cf6", mb: 0.75 }}
                >
                  1. Set Your BET
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: colors.slate[600], lineHeight: 1.6 }}
                >
                  Choose the amount of BET you want to wager per spin.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  p: 2.5,
                  bgcolor: "#f8fafc",
                  borderRadius: borderRadiusPx.lg,
                  border: `1px solid ${colors.slate[200]}`,
                  height: "100%",
                  transition: "border-color 0.2s ease, box-shadow 0.2s ease",
                  "&:hover": {
                    borderColor: "#d8b4fe",
                    boxShadow: "0 4px 12px rgba(139, 92, 246, 0.08)",
                  },
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 800, color: "#8b5cf6", mb: 0.75 }}
                >
                  2. Spin the Reels
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: colors.slate[600], lineHeight: 1.6 }}
                >
                  Click SPIN and watch the three reels spin. Match all three symbols on the center payline to win big!
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  p: 2.5,
                  bgcolor: "#f8fafc",
                  borderRadius: borderRadiusPx.lg,
                  border: `1px solid ${colors.slate[200]}`,
                  height: "100%",
                  transition: "border-color 0.2s ease, box-shadow 0.2s ease",
                  "&:hover": {
                    borderColor: "#d8b4fe",
                    boxShadow: "0 4px 12px rgba(139, 92, 246, 0.08)",
                  },
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 800, color: "#8b5cf6", mb: 0.75 }}
                >
                  3. Win Jackpots
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: colors.slate[600], lineHeight: 1.6 }}
                >
                  Progressive jackpots are built from community wagers. Win the Mini, Major, or Mega jackpot based on your symbol matches.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default ThreeSlotWorking;
